module.exports = __webpack_public_path__ + "assets/img/100101.00236795.svg";